var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRightTop(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 313,
    height: 125,
    viewBox: "0 0 313 125",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M313 -31.5C313 54.9326 242.933 125 156.5 125C70.0674 125 0 54.9326 0 -31.5C0 -117.933 70.0674 -188 156.5 -188C242.933 -188 313 -117.933 313 -31.5ZM59.5654 -31.5C59.5654 22.0355 102.965 65.4346 156.5 65.4346C210.035 65.4346 253.435 22.0355 253.435 -31.5C253.435 -85.0355 210.035 -128.435 156.5 -128.435C102.965 -128.435 59.5654 -85.0355 59.5654 -31.5Z",
    fill: "#0B2E75",
    fillOpacity: 0.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightTop);
export default __webpack_public_path__ + "static/media/right-top.bec3f4ecbd04c3036c5bd938c3b95eb8.svg";
export { ForwardRef as ReactComponent };